import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import Badge from '@mui/material/Badge';

const NotificationIcon = ({ count, onClick }) => {
    return (
        <div onClick={onClick} style={{ cursor: "pointer" }}>
            <Badge badgeContent={count} color="error">
                <NotificationsOutlinedIcon />
            </Badge>
        </div>
    );
};

export default NotificationIcon;